import React from 'react';
import { formatJoinedCallTag } from '../../constants/coSellerCalls';

/** A joined call is a category, not a status: the list's one neutral chip. */
const JOINED_CALL_TAG_CLASS =
  'inline-flex items-center px-2.5 py-1 text-xs font-semibold rounded-full bg-surface-sunken text-ink-secondary';

interface JoinedCallTagProps {
  /** The call owner's display name, from the backend's `ownerName`. */
  ownerName?: string | null;
}

/** "Joined <owner>'s call": a call the viewer joined with their own mic (co-seller). */
export const JoinedCallTag: React.FC<JoinedCallTagProps> = ({ ownerName }) => (
  <span data-testid="joined-call-tag" className={JOINED_CALL_TAG_CLASS}>
    {formatJoinedCallTag(ownerName)}
  </span>
);
